import { Cloud, Music } from "lucide-react";
import React from "react";

export type Provider = "local" | "spotify";

interface ProviderTabsProps {
  activeProvider: Provider;
  onProviderChange: (provider: Provider) => void;
  showLocalTab?: boolean;
  showSpotifyTab?: boolean;
}

export const ProviderTabs: React.FC<ProviderTabsProps> = ({
  activeProvider,
  onProviderChange,
  showLocalTab = true,
  showSpotifyTab = true,
}) => {
  if (!showLocalTab && !showSpotifyTab) return null;

  return (
    <div className="flex gap-2 mb-6">
      {showLocalTab && (
        <button
          onClick={() => onProviderChange("local")}
          className={`flex items-center gap-2 px-4 py-2 rounded-full transition ${
            activeProvider === "local"
              ? "bg-yellow-500 text-white"
              : "bg-zinc-800 text-zinc-400 hover:bg-zinc-700 hover:text-white"
          }`}
        >
          <Music className="w-4 h-4" />
          Local
        </button>
      )}

      {showSpotifyTab && (
        <button
          onClick={() => onProviderChange("spotify")}
          className={`flex items-center gap-2 px-4 py-2 rounded-full transition ${
            activeProvider === "spotify"
              ? "bg-yellow-500 text-white"
              : "bg-zinc-800 text-zinc-400 hover:bg-zinc-700 hover:text-white"
          }`}
        >
          <Cloud className="w-4 h-4" />
          Spotify
        </button>
      )}
    </div>
  );
};
